import InputWrapper from "./input-wrapper";
export interface SkipProps {
  name?: string;
  onClick: () => void;
}
const Skip = ({ name, onClick }: SkipProps) => {
  return (
    <InputWrapper label="">
      <button
        className="signup-btn p-5 flex mt-5"
        type="button"
        onClick={onClick}
      >
        {name || "رد کردن"}
        <span className="sepanta-icon-left-long-arrow"></span>
      </button>
    </InputWrapper>
  );
};

export default Skip;
